export type SocialApp =
  | 'membersAbout'
  | 'membersFF'
  | 'wixForum'
  | 'wixBlog'
  | 'socialGroups'
  | 'wixEvents';

export const socialApps: SocialApp[] = [
  'membersAbout',
  'membersFF',
  'wixForum',
  'wixBlog',
  'socialGroups',
  'wixEvents',
];
